var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-415 -316)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 10,
    transform: "translate(415 316)",
    fill: "#0cf"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126 -176)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-431.5 157.744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1006.763,346.969l-13.093,8.393-13.093-8.393,13.093-8.393Z",
    transform: "translate(-0.065)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.708,397.5v16.807h-.011L993.6,422.7l-13.093-8.393H980.5V397.5",
    transform: "translate(0 -50.531)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 16.808,
    transform: "translate(993.604 355.373)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.5,409.723V392.916l6.695-4.416,3.7,2.279-6.41,4.558v16.828",
    transform: "translate(-29.157 -42.813)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductImage);
export default __webpack_public_path__ + "static/media/productImage.44a4d5c358013d58b9907432e1d2785d.svg";
export { ForwardRef as ReactComponent };